
// "Click on" the given URL.
// Optionally, call a provided callback when done, and download
// as the supplied download filename.
export function triggerUrl(url, onUrlLoaded=undefined, filename=undefined) {
  var link = document.createElement('a');
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function() {
    var file = new Blob([xhr.response], { type : 'application/octet-stream' });
    link.setAttribute('href', window.URL.createObjectURL(file));
    var download_filename = filename;
    if (!filename) {
      download_filename = getUrlFilename(url);
    }
    link.setAttribute('download', download_filename);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (onUrlLoaded) {
      onUrlLoaded();
    }
  }
  xhr.send();
}

export function getUrlFilename(url) {
  const parts = new URL(url).pathname.split('/');
  const s3Key = decodeURIComponent(parts[parts.length - 1]);
  const filename = s3Key.split('/').pop();
  return filename;
}

export function makeMailtoHref(address, subject, body) {
  const bodyClean = body.replace(/(?:\r\n|\r|\n)/g, '%0D%0A');
  const mailtoHref = `mailto:${address}?subject=${subject}&body=${bodyClean}`;
  return mailtoHref;
}
